if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      // this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          // this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

//
// // Check product variant availability
// document.addEventListener('DOMContentLoaded', function() {
//
//   console.log('Données du produit product form:', window.product);
//
//   // const availabilityMessage = document.getElementById('availability-message');
//
//
//   function updateAvailabilityMessage() {
//       const productForm = document.querySelector('form.form');
//       if (!productForm) return;
//
//       const formData = new FormData(productForm);
//       const variantId = formData.get('id');
//
//       // Vérifiez si les données du produit sont disponibles
//       if (typeof window.product === 'undefined') {
//           console.error('Les données du produit ne sont pas disponibles.');
//           return;
//       }
//
//       const productData = window.product;
//
//       // Vérifiez si les variantes sont disponibles
//       if (!productData.variants) {
//           console.error('Les variantes du produit ne sont pas disponibles.');
//           return;
//       }
//       // console.log(productData);
//       const variant = productData.variants.find(v => v.id == variantId);
//
//       const addToCartButton = document.querySelector('input[value="'+variant.id+'"] + .product-form__buttons .product-form__submit');
//       console.log(variant);
//
//       if (variant && variant.available) {
//           // availabilityMessage.textContent = 'Le produit est disponible.';
//           // availabilityMessage.style.color = 'green';
//           // availabilityMessage.style.display = 'none';
//           setTimeout(function(){
//               addToCartButton.disabled = false;
//               addToCartButton.textContent = 'Ajouter au panier';
//           },1000);
//       } else {
//           // availabilityMessage.textContent = 'Le produit est en rupture de stock.';
//           // availabilityMessage.style.color = 'red';
//           // availabilityMessage.style.display = 'block';
//           setTimeout(function(){
//               addToCartButton.disabled = true;
//               addToCartButton.textContent = 'Rupture de stock';
//           },1000);
//       }
//   }
//
//   // Écouter les changements sur les sélecteurs de variantes
//   const variantSelectors = document.querySelectorAll('input[name="id"]');
//   variantSelectors.forEach(selector => {
//       console.log(selector);
//       selector.addEventListener('change', updateAvailabilityMessage);
//   });
//
//   // Mettre à jour le message de disponibilité lors du chargement initial
//   updateAvailabilityMessage();
// });

